module.exports = __webpack_public_path__ + "e-magnet.png?a0394cc5eac7e31ab5caee5ffb123a44";